import { render, staticRenderFns } from "./TasksListing.vue?vue&type=template&id=47a9cf88&scoped=true&"
import script from "./TasksListing.vue?vue&type=script&lang=js&"
export * from "./TasksListing.vue?vue&type=script&lang=js&"
import style0 from "./TasksListing.vue?vue&type=style&index=0&id=47a9cf88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a9cf88",
  null
  
)

export default component.exports